<template>
  <div class="general-frame">
    <div class="general-neick">
      <div
        style="
        display: flex;
        justify-content: space-between;
        padding:15px;
        align-items: end;
      "
      >
        <div
          style="width: 25%;box-shadow: #DCDFE6 0 0 30px inset;border-radius: 8px"
        >
          <div style="padding: 20px; font-size: 14px">
            <div style="text-align: center;">
              <img
                style="width: 130px;border-radius: 71px;border: 2px solid;box-shadow: rgb(7, 65, 122) 0px 0px 30px inset;"
                :src="list.sex == 'female' ? legend.headImg1 : legend.headImg2"
              />
            </div>
            <div style="font-size: 15px; margin: 15px 0px">
              <p style="margin-bottom: 5px"></p>
              <p style="margin-bottom: 5px; letter-spacing: 1px"></p>
            </div>
            <ul class="userItem">
              <li>
                <span>性别：</span>
                <span>{{ list.sex == "female" ? "女" : "男" }}</span>
              </li>
              <li>
                <span>账号：</span>
                <span>{{ list.userName }}</span>
              </li>
              <li>
                <span>姓名：</span>
                <span>{{ list.realName }}</span>
              </li>
              <li>
                <span>类型：</span>
                <span>{{ list.roleName }}</span>
              </li>
              <li>
                <span>电话：</span>
                <span>{{ list.telPhone }}</span>
              </li>
              <li>
                <span>公司：</span>
                <span>{{ list.companyName }}</span>
              </li>
            </ul>
            <div style="text-align: center;padding: 10px 0 0px;">
              <router-link :to="{path:'/userDetails', query:{ personal:list.id}}">
                <el-button
                  type="primary"
                  @click="getModification()"
                  icon="el-icon-edit"
                >编辑信息
                </el-button>
              </router-link>
            </div>
          </div>
        </div>
        <div
          style="width: 72%;    box-shadow: #DCDFE6 0 0 30px inset; border-radius: 8px"
        >
          <div style="padding: 20px 20px 0 20px" class="tab">
            <el-tabs type="card" v-model="activeName">
              <el-tab-pane label="修改密码" name="top">
                <el-form
                  :model="ruleForm"
                  status-icon
                  :rules="rules"
                  ref="ruleForm"
                  label-width="100px"
                  class="demo-ruleForm"
                  style="width: 60%; margin: 30px auto"
                >
                  <el-form-item label="原密码" prop="oldPass">
                    <el-input type="password" v-model="ruleForm.oldPass"></el-input>
                  </el-form-item>
                  <el-form-item label="新密码" prop="newPass">
                    <el-input type="password" v-model="ruleForm.newPass"></el-input>
                  </el-form-item>
                  <el-form-item label="确认密码" prop="newPassWord">
                    <el-input type="password" v-model="ruleForm.newPassWord"></el-input>
                  </el-form-item>
                  <el-form-item style="text-align: center;">
                    <el-button
                      type="primary"
                      @click="changePassword('ruleForm')"
                      icon="el-icon-edit"
                      size="medium"
                      style="margin-right: 10px"
                    >修改
                    </el-button>
                    <el-button
                      @click="resetForm('ruleForm')"
                      size="medium"
                      icon="el-icon-refresh"
                    >重置
                    </el-button>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  components: {},
  data() {
    var validatePass1 = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error("原密码不能为空!"));
      } else {
        callback();
      }
    };

    var validatePass2 = (rule, value, callback) => {
      const reg = /(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*?._+|/]+)$)^[\w~!@#$%^&*?._+|/]{1,16}/;
      if (value.length === 0) {
        callback(new Error("新密码不能为空!"));
      } else if (value.length < 8) {
        callback(new Error("新密码长度需为8-16个字符!"));
      } else if (value.length > 16) {
        callback(new Error("新密码长度需为8-16个字符!"));
      } else if (!reg.test(value)) {
        callback(new Error("新密码必须包含字母、数字、符号中至少2种!"));
      } else if (value == this.ruleForm.oldPass) {
        callback(new Error("新密码不能与原密码相同!"));
      } else {
        callback();
      }
    };
    var validatePass3 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码!"));
      } else if (value !== this.ruleForm.newPass) {
        callback(new Error("两次输入密码不一致!"));
      } else if (value == this.ruleForm.oldPass) {
        callback(new Error("新密码不能与原密码相同!"));
      } else {
        callback();
      }
    };
    return {
      list: {},
      activeName: "top",
      legend: {
        headImg2: require("../../../img/svg/useHead.svg"),
        headImg1: require("../../../img/svg/useHeadFemale.svg"),
      },
      ruleForm: {
        oldPass: "",
        newPass: "",
        newPassWord: "",
      },
      rules: {
        oldPass: [{validator: validatePass1, trigger: "blur"}],
        newPass: [{validator: validatePass2, trigger: "blur"}],
        newPassWord: [{validator: validatePass3, trigger: "blur"}],
      },
    };
  },
  methods: {
    //用户信息接口
    getList() {
      this.get("user/getPageList", {
        id: localStorage.getItem("useId"),
      }).then((res) => {
        this.list = res.data.rows[0];
      });
    },

    //修改密码
    changePassword(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          if (this.ruleForm.newPass === this.ruleForm.newPassWord) {
            this.post("user/changePassword", {
              password: this.ruleForm.oldPass,
              passwordNew: this.ruleForm.newPassWord,
            }).then((res) => {
              if (res.data.code != 200) {
                this.$message.error(res.data.msg);
              } else {
                this.$message({
                  message: "密码修改成功，请您重新登录",
                  type: "success",
                });
                this.$refs.ruleForm.resetFields();
                window.localStorage.clear();
                this.$router.push({path: "/"});
              }
            });
          } else {
            this.$message.error("确认密码必须与新密码保持一致");
          }
        }
      });
    },


    //编辑资料
    getModification() {

    },

    //重置
    resetForm(ruleForm) {
      this.$refs[ruleForm].resetFields();
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style scoped>
.userItem li {
  margin: 0px 0px 15px 15px;
  font-size: 15px;
}

.tab /deep/ .el-form-item {
  margin-bottom: 40px;
}

ul {
  padding-inline-start: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/menu/personal/personalCenter.vue